module.exports = __webpack_public_path__ + "a1a9c92492478cca2a7a337826f335e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_person_different_team.png
// module id = 29
// module chunks = 0 1 2 3 4